<template>
    <div>
        <slot name="activator" :on="on">
            <button class="btn btn-primary btn-block" v-on="on">
                Open Overlay
            </button>
        </slot>
        <transition name="modal" v-if="dialog">
            <div class="mask">
                <div class="modal show" id="modalContainer" >
                    <div class="modal-dialog modal-dialog-centered" role="document">
                        <div class="modal-content">
                            <div class="modal-header" v-if="hasHeader">
                                <slot name="header"></slot>
                            </div>
                            <div class="modal-body">
                                <div class="container-fluid">
                                    <slot name="content"></slot>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <div class="row" style="padding-bottom: 10px; width: 100%">
                                    <div class="col" style="text-align: left">
                                        <slot name="actions"></slot>
                                    </div>
                                    <div class="col" style="text-align: right">
                                        <button type="button" class="btn btn-secondary" @click="dialog = false">OK</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: "Modal",
    props: {
        title: {
            type: String, 
            required: false,
            default: ""
        }
    },
    computed: {
        hasHeader: function() {
            return !!this.$slots.header;
        },

    },
    methods: {
        open: function() {
            this.dialog = true;
        }
    },
    data() {
        return {
            on: {
                click: this.open
            },
            dialog: false
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 5px;
    
    .mask {
        position: fixed;
        z-index: 10001;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: table;
    }

    #modalContainer {
        display: block;
    }

    .modal-dialog {
        width: 100%;
        max-width: 900px;
    }

    @media (max-width: 575.98px) { 
        .modal-dialog {
            padding-right: 16px;
        }
    }

    div.modal-header {
        padding: 32px;
        padding-right: 0px;
    }
    

    .modal-body {
        max-height: 50vh;
        overflow-y: auto;
    }


    .modal-content {
        border-radius: 5px;
    }

    .btn {
        border-radius: $border-radius;
    }

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.enter {
  opacity: 0;
}

.leave-active {
  opacity: 0;
}

.enter .container,
.leave-active .container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>